module.exports = __webpack_public_path__ + "img/logo_title.24c95239.png";